import { Injectable } from '@angular/core';

import { Router } from '@angular/router';

import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import axios from './axios';

import momentJalaali from 'moment-jalaali';

import * as XLSX from 'xlsx';

import { Meta, Title } from '@angular/platform-browser';

import { Location } from '@angular/common';

import { GurdServiceService } from './gurd-service.service';

import { BehaviorSubject } from 'rxjs';
import { SignalrService } from './signalr.service';

declare let $: any;

@Injectable({

  providedIn: 'root',

})

export class OtherService {

  private isHolidayClicked = new BehaviorSubject<boolean>(false);

  webAppName = (<any>window).webAppName;

  isHolidayClicked$ = this.isHolidayClicked.asObservable();

  MetaDefinition = [

    { name: 'ردیاب خودرو', content: 'ردیاب خودرو' },

    { name: 'مدیریت ناوگان', content: 'مدیریت ناوگان' },

    { name: 'نرم افزار ردیاب خودرو', content: 'نرم افزار ردیاب خودرو' },

    { name: 'ردیاب موتورسیکلت', content: 'ردیاب موتورسیکلت' },

    { name: 'ردیاب حیوانات خانگی', content: 'ردیاب حیوانات خانگی' },

    { name: 'ردیاب شخصی', content: 'ردیاب شخصی' },

    { name: 'ردیاب بیمار', content: 'ردیاب بیمار' },

    { name: this.webAppName, content: this.webAppName }

  ]

  constructor(

    private router: Router,

    private meta: Meta,

    private location: Location,

    private gurdService: GurdServiceService,

    private _tabTitle: Title,

    // private _signalRService: SignalrService,

  ) { }

  holiday_Status(isClicked: boolean) {

    this.isHolidayClicked.next(isClicked);

  }

  removeLocalStorage() {
    window.localStorage.clear();
    this.nonespinner();
  }

  getLink = async (type: number) => {
    const resp = await axios.post(
      `GetURL?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!) ? this.gurdService.decrypt(window.localStorage.getItem('ID')!) : -1}&tiType=${type}`
    );
    window.open(resp.data, '_blank');
    //window.location.href=`${resp.data}`;
  };

  insertComma(e: any) {
    var element = $(e.target).closest('input')[0];
    var txtObj = element;
    var txtVal = this.replaceAll(txtObj.value, ',', '');
    if (txtObj.value != '') {
      txtObj.value = this.insertCammaOnText(txtVal);
    }
  }

  replaceAll(txt: any, replace: any, with_this: any) {
    return txt.replace(new RegExp(replace, 'g'), with_this);
  }

  insertCammaOnText(textValue: any) {
    if (textValue != '') {
      var newVal = '';
      for (var i = 0; i < textValue.length; i++) {
        newVal = newVal + textValue.substring(i, i + 1);
        if ((textValue.length - (i)) % 3 == 0 && i < textValue.length) {
          newVal = newVal + ',';
        }
      }
      return newVal;
    } else {
      return '';
    }
  }

  nonespinner() {
    var sp = document.getElementById('spinner') as any;
    sp.classList.add('d-none');
  }

  Showspinner() {
    var sp = document.getElementById('spinner') as any;
    sp.classList.remove('d-none');
  }

  login = async () => {

    if (this.gurdService.decrypt(window.localStorage.getItem('pass')!) == null || this.gurdService.decrypt(window.localStorage.getItem('pass')!) == undefined) {

      // this.router.navigate(['/login']);

      this.router.navigate(['/login'], { queryParams: { ERR_CODE: 9 } });

      return;


    }

    if (!this.gurdService.decrypt(window.localStorage.getItem('menu')!)) {

      var model = {

        strPassword: this.gurdService.decrypt(window.localStorage.getItem('pass')!),

        strUserName: this.gurdService.decrypt(window.localStorage.getItem('UserName')!),

      };

      const resp = await axios.post('Login4Radyab', model).then(async (response: any) => {

        if (response.data.Result != 1) {

          this.removeLocalStorage();

          // this.router.navigate(['/login']);
          this.router.navigate(['/login'], { queryParams: { ERR_CODE: 10 } });
          return;
        }

        if (response.data.Result == 1) {

          var model2 = {

            iSystemUser: response.data.Id,

            strSession: response.data.strSession,

          }

          const resp2 = await axios.post("GetRadyabUserAbility2", model2) as any;

          if (resp2.data.ISSessionExpired == true) {

            this.removeLocalStorage();

            // this.router.navigate(['login']);

            this.router.navigate(['login'], { queryParams: { error: '131' } });


            return;

          }


          resp2.data = JSON.parse(resp2.data);

          localStorage.setItem('Session', this.gurdService.encrypt(response.data.strSession));

          localStorage.setItem('ID', this.gurdService.encrypt(response.data.Id).toString());

          localStorage.setItem('companyName', this.gurdService.encrypt(response.data.strCompanyName));

          localStorage.setItem('FullName', this.gurdService.encrypt(response.data.strFullName));

          localStorage.setItem('UnitID', this.gurdService.encrypt(response.data.strUnitID).toString());

          localStorage.setItem('UserName', this.gurdService.encrypt(response.data.strUserName));

          if (window.localStorage.getItem("version") != response.data.strWebAppVersion) {

            localStorage.setItem('version', response.data.strWebAppVersion);

            window.location.href = window.location.href

          }

          else {
            localStorage.setItem('version', response.data.strWebAppVersion);
          }

          var acsess = {
            bEnableAddCar: response.data.bEnableAddCar,
            bEnableSOS: response.data.bEnableSOS,
            bEnableIntroducedMobile: response.data.bEnableIntroducedMobile,
            bSupport: response.data.bSupport,
            bEnableEditCar: response.data.bEnableEditCar,
            bEnableDashboard: response.data.bEnableDashboard,
            bEnableAddID: response.data.bEnableAddID,
            bEnableGeoFance: response.data.bEnableGeoFance,
            bEnableCommand: response.data.bEnableCommand,
            bEnableCarRvenues: response.data.bEnableCarRvenues,
            bEnableTiket: response.data.bEnableTiket,
            bShop: response.data.bShop,
          } as any;

          for (let index = 0; index < resp2.data.length; index++) {

            acsess[resp2.data[index].strXenotakAbility] = resp2.data[index].bHas == 0 ? false : true
          }

          localStorage.setItem('menu', this.gurdService.encrypt(JSON.stringify(acsess)));

        }

      }).catch(error => {

        this.removeLocalStorage();

        // this.router.navigate(['/login']);

        this.router.navigate(['/login'], { queryParams: { ERR_CODE: 11 } });

      });

    }

  };

  guid = async (Id: any) => {
    const resp = await axios.post(`Radyab_OnlineHelp?iHelpID=${Id}`);
    $.confirm({
      title: `${resp.data ? resp.data : "راهنمایی تعریف نشده است."}`,
      content: '',
      type: 'green',
      buttons: {
        ok: {
          text: "بستن",
          btnClass: 'btn-primary',
          keys: ['enter'],
          action: () => {
            return;

          }
        },

      }
    });
  }

  exportexcel(id: any, fileName: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);
  }

  returnCorrectPlate(input: any) {
    let array = input.split(' ').reverse(); 1
    return array[0] + ' ' + array[1] + ' ' + array[2] + ' ' + array[3] + ' ' + array[4]
  }

  getSeparatedValue(input: any) {
    return new Number(input).toLocaleString('fa-ir')
  }

  setMetaTags() {
    this.meta.addTags(this.MetaDefinition, false)
  }

  getCurrentDate() {
    return momentJalaali().locale('fa').format('jYYYY/jMM/jDD');
  }

  goBack() {
    this.location.back();
  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      }
    });
  }

  markAllAsUnTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsUntouched({ onlySelf: false });
      } else if (control instanceof FormGroup) {
        this.markAllAsUnTouched(control);
      }
    });
  }

  // takes an object and convert string that contain number to number and return it 

  stringNumberToNumber(obj: any): any {

    const allowedWord = ['i', 'ti', 'f', 'd'];

    for (const key in obj) {

      if (typeof obj[key] === 'string') {

        const cleanedValue = obj[key].replace(/,/g, '');

        if (!isNaN(parseFloat(cleanedValue))) {

          for (const word of allowedWord) {

            if (key.startsWith(word)) {

              obj[key] = parseFloat(cleanedValue);

              break; // Exit inner loop once a match is found

            }

          }

        }

      }

    }

    return obj;

  }

  // custom validator that allows 0 as a valid value

  zeroOrMoreValidator(): ValidatorFn {

    return (control: AbstractControl): ValidationErrors | null => {

      const value = control.value;

      if (value === null || value === undefined || value === '' || value == -1) {

        return { required: true }; // Error for empty value

      }

      return null; // Valid if not empty or 0

    };

  }

  // return strValue for custom-filter

  initialFilterValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    if (!strKeyValue || !strKeyValue?.toString() || strKeyValue?.toString().trim() == '') return '';

    if (strKeyValue.toString() == '' || strKeyValue.toString() == '-1') {

      return '';

    }

    else {

      let lst_Temp: any[] = lst_;

      lst_Temp = lst_Temp.filter((el) => { return el[strKey] == strKeyValue });

      return lst_Temp[0] ? lst_Temp[0][strComment] : ''

    }

  }

  // تغییر عنوان صفحه

  setTitle(newTitle: string) {

    this._tabTitle.setTitle(newTitle != '' ? newTitle : this.webAppName);

  }

}